import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import { RouterLogic } from '../Router';

function useRouterLogic(): RouterLogic {
  const { routingModule } = useUILogic();
  const currentView = routingModule.currentView;

  return { currentView };
}

export { useRouterLogic };
